<template>

</template>

<script>
    import PreviewButtonElement from "./PreviewButtonElement";
    import { mapState } from 'vuex';
    const states = [
        'logged-out',
        'logged-in'
    ];

    export default {
        name: "PreviewAffiliatesButtonElement",
        mixins: [            
            PreviewButtonElement            
        ],
        computed: {
            ...mapState('user', [
                'user'
            ])
        },
        mounted(){
            if(this.myNode.classList.contains('js-affiliate-sign-up')){
                this.addSignupListener();
            } else if(this.myNode.classList.contains('js-affiliate-sign-in')){
                this.addSigninListener();
            } else if(this.myNode.classList.contains('js-affiliate-join')){
                this.addJoinListener();
            }
            
        },
        methods: {
            addSignupListener(){
                this.myNode.addEventListener('click', ()=>{                   
                   l_settings.redirectUrl = glueParamsToUrl(window.location.href, {affiliateSignin: true});
                   l_settings.signup = 'learnworlds';
                   l_settings.showRegisterForm();
                });
            },
            addSigninListener(){
                this.myNode.addEventListener('click', ()=>{
                    l_settings.redirectUrl = glueParamsToUrl(window.location.href, {affiliateSignin: true});
                    l_settings.signup = 'learnworlds';
                    l_settings.showEnterOnlyForm();
                });
            },
            addJoinListener(){
                this.myNode.addEventListener('click', ()=>{
                    const termsCheckbox = this.myNode.closest('.affiliates-registration-wrapper').querySelector('.js-affiliate-terms');
                    if(!termsCheckbox.checked){
                        displayError([{'context' :'affiliate_program_terms_not_checked'}],'affiliates');                       
                        return;
                    }
                    
                    $.ajax({
                        url: server + 'affiliate/join',
                        async: true,
                        type: 'POST',
                        success: function (data) {
                            if (data.success) {                        
                                window.location.href = '/author/affiliate?tab=dashboard&inner_welcome=true';
                            }else{
                                displayError(data.errors)    
                            }
                        },
                        error: function (error) {
                            displayError(error.responseText)
                        }
                    })
                });
            }
           
        }
    }
</script>



